const actions = {
    REGISTER_START: 'REGISTER_START',
    REGISTER_SUCCESS: 'REGISTER_SUCCESS',
    REGISTER_FAILURE: 'REGISTER_FAILURE',
    LOGIN_START: 'LOGIN_START',
    OFFLINE_LOGIN_START: 'OFFLINE_LOGIN_START',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
    CHANGE_PASSWORD_START: 'CHANGE_PASSWORD_START',
    CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
    CHANGE_PASSWORD_FAILURE: 'CHANGE_PASSWORD_FAILURE',
    VERIFY_PASSWORD_START: 'VERIFY_PASSWORD_START',
    VERIFY_PASSWORD_SUCCESS: 'VERIFY_PASSWORD_SUCCESS',
    VERIFY_PASSWORD_FAILURE: 'VERIFY_PASSWORD_FAILURE',
    USER_DETAILS_START: 'USER_DETAILS_START',
    USER_DETAILS_SUCCESS: 'USER_DETAILS_SUCCESS',
    USER_DETAILS_FAILURE: 'USER_DETAILS_FAILURE',
    CLEAR_PASSWORD_START: 'CLEAR_PASSWORD_START',
    CLEAR_PASSWORD_SUCCESS: 'CLEAR_PASSWORD_SUCCESS',
    CHANGE_EMAIL_START: 'CHANGE_EMAIL_START',
    CHANGE_EMAIL_SUCCESS: 'CHANGE_EMAIL_SUCCESS',
    CHANGE_EMAIL_FAILURE: 'CHANGE_EMAIL_FAILURE',
    LOGOUT_START: 'LOGOUT_START',
    LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
    UPDATE_PROFILE_DETAILS_START: 'UPDATE_PROFILE_DETAILS_START',
    UPDATE_PROFILE_DETAILS_SUCCESS: 'UPDATE_PROFILE_DETAILS_SUCCESS',
    UPDATE_PROFILE_DETAILS_FAILURE: 'UPDATE_PROFILE_DETAILS_FAILURE',
    FORGOT_PASSWORD_START: 'FORGOT_PASSWORD_START',
    FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_SUCCESS',
    FORGOT_PASSWORD_FAILURE: 'FORGOT_PASSWORD_FAILURE',
    VERIFY_OTP_START: 'VERIFY_OTP_START',
    VERIFY_OTP_SUCCESS: 'VERIFY_OTP_SUCCESS',
    VERIFY_OTP_FAILURE: 'VERIFY_OTP_FAILURE',
    RESET_PASSWORD_START: 'RESET_PASSWORD_START',
    RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
    RESET_PASSWORD_FAILURE: 'RESET_PASSWORD_FAILURE',

    ROLE_MANAGEMENT_START: 'ROLE_MANAGEMENT_START',
    ROLE_MANAGEMENT_SUCCESS: 'ROLE_MANAGEMENT_SUCCESS',
    ROLE_MANAGEMENT_ERROR: 'ROLE_MANAGEMENT_ERROR'
};

export default actions;